common.View.create('galaxy::components.Accordion', {

    onDOMLoad()
    {
        this.initAccordionItems();
    },

    initAccordionItems()
    {
        this.element.find('.galaxy\\:\\:components-AccordionTab')
            .find('> .head')
                .on('click', (event) => {
                    let $element = $(event.currentTarget).parent().find('> .content');

                    // Slide all up?
                    if( this.element.data('closeAll') ) {
                        this.element.find('.galaxy\\:\\:components-AccordionTab').slideUp();
                    }

                    // Is already open?
                    if( $element.is(':visible') ) {
                        $element.slideUp();
                    } else {
                        $element.slideDown();
                    }
                })
                .end();
    }

});
